import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { ArrowsRotateSpinIcon } from '@repo/icons';
export default function LoadingOverlay({ loading, className, children }) {
    return (_jsxs("div", { className: classNames('relative', className), children: [loading && (_jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: _jsx(ArrowsRotateSpinIcon, {}) })), _jsx("div", { className: classNames({ 'blur-sm': loading }), children: children })] }));
}
